import { Display2 } from '@sainsburys-tech/luna-typography';
import * as React from 'react';
export default {
  Display2,
  React
};